import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Avatar from 'components/Avatar'
import SiteLogo from 'components/SiteLogo'
import { T, Membership } from 'components/Translations'
import Navigation from './Navigation'
import Copyright from './Copyright'
import MobileMenu from './MobileMenu'
import HamburgerButton from './HamburgerButton'
import StyledSidebar from './StyledSidebar'

const Sidebar = ({ middle, bottom, routes, user, intro, locationKey, externalLogo = false }) => {
  const [isOpen, setOpen] = useState(false)

  useEffect(() => {
    setOpen(false)
  }, [locationKey])

  return [
    <StyledSidebar key={1} active={isOpen}>
      <SiteLogo external={externalLogo} />

      {user && (
        <Link to="/myprofile" className="slot profile-link">
          <Avatar user={user} size="thumbnail" />
          <div className="text">
            <div className="username">{user.screenName}</div>
            <Membership className="membership" as="p" user={user} />
          </div>
        </Link>
      )}

      <MobileMenu />
      <div className="slot-group">
        <Navigation className="slot slot1" routes={routes} intro={intro} />
        <div className="slot slot2">{middle}</div>
      </div>

      <div className="slot slot3">{bottom}</div>

      {user && <T as={Link} label="actions/logout" className="link logout" to="/logout" />}

      <div className="footer">
        <Copyright />
      </div>
    </StyledSidebar>,

    <HamburgerButton key={2} onClick={() => setOpen(!isOpen)} isOpen={isOpen} />,
  ]
}

export default connect(s => ({
  user: s.myProfile,
  locationKey: s.router.location.key,
  intro: s.account.intro,
}))(Sidebar)
